var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "articlePage" }, [
    this.$store.state.webNavigator == "pc"
      ? _c("div", [
          _c("div", { staticClass: "max1720 news-list flexStart" }, [
            _c(
              "div",
              [
                _c("twoLevelList", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pageType,
                      expression: "pageType"
                    }
                  ],
                  attrs: {
                    classCode: _vm.classType,
                    titles: _vm.titles,
                    tltType: _vm.twolist ? "1" : "2",
                    act: _vm.active ? _vm.active : "",
                    twolist: _vm.navLsit,
                    toLeveListPath: _vm.toLeveListPath
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "news-list-left" },
              _vm._l(_vm.newslist, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "news-list-bar pointEr",
                    on: {
                      click: function($event) {
                        return _vm.gotoPath(item)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "news-bar-left displayIB" }, [
                      _c("img", {
                        staticClass: "news-list-img",
                        attrs: {
                          src: _vm.httptype(item.articleImg),
                          alt: item.pictag ? item.pictag : "",
                          title: ""
                        }
                      })
                    ]),
                    _c(
                      "div",
                      { staticClass: "news-bar-right displayIB positionRE" },
                      [
                        _c("div", { staticClass: "font26px news-list-Tlt" }, [
                          _vm._v(_vm._s(item.articleTitle))
                        ]),
                        _c(
                          "div",
                          { staticClass: "font16px col666666 news-list-Text" },
                          [_vm._v(_vm._s(_vm.ellipsis(item.simpleContent)))]
                        ),
                        item.simpleContent
                          ? _c("span", { staticClass: "font16px col00CDA2" }, [
                              _vm._v("查看全文>>")
                            ])
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass:
                              "font16px col99999 news-list-icon positionAB"
                          },
                          [
                            _c("span", {
                              staticClass: "Time-down text-down displayIB"
                            }),
                            _c("span", [_vm._v(_vm._s(item.submissionTime))]),
                            _c("span", {
                              staticClass: "see-down text-down displayIB"
                            }),
                            _c("span", [_vm._v(_vm._s(item.viewingCount))])
                          ]
                        )
                      ]
                    )
                  ]
                )
              }),
              0
            ),
            _c(
              "div",
              { staticClass: "news-list-right" },
              [_c("articleSidebar")],
              1
            )
          ])
        ])
      : _vm._e(),
    this.$store.state.webNavigator == "phone"
      ? _c("div", [
          _c("div", [
            _c(
              "div",
              { staticClass: "articlePhone-list" },
              [
                _c(
                  "div",
                  [
                    _c("twoLevelList", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.titles != "品牌资讯",
                          expression: "titles!='品牌资讯'"
                        }
                      ],
                      attrs: {
                        classCode: _vm.classType,
                        titles: _vm.titles,
                        tltType: _vm.twolist ? "1" : "2",
                        act: _vm.active ? _vm.active : "",
                        twolist: _vm.navLsit,
                        toLeveListPath: _vm.toLeveListPath
                      }
                    })
                  ],
                  1
                ),
                _vm._l(_vm.newslist, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "articlePhone-listBar",
                      on: {
                        click: function($event) {
                          return _vm.gotoPath(item)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "displayIB articlePhone-ImgBox" },
                        [
                          _c("img", {
                            staticClass: "articlePhone-listImg",
                            attrs: {
                              src: _vm.httptype(item.articleImg),
                              alt: item.pictag ? item.pictag : "",
                              title: ""
                            }
                          })
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "displayIB articlePhone-TextBox" },
                        [
                          _c(
                            "div",
                            { staticClass: "articlePhone-listP font24phone" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.PhoneEllipsis(item.articleTitle, "1")
                                )
                              )
                            ]
                          ),
                          _c("div", { staticClass: "font20phone col99999" }, [
                            _c("div", { staticClass: "articlePhone-listP2" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.PhoneEllipsis(item.simpleContent, "2")
                                ) + "\n                "
                              ),
                              item.simpleContent
                                ? _c("span", { staticClass: "col00CDA2" }, [
                                    _vm._v("查看全文>>")
                                  ])
                                : _vm._e()
                            ])
                          ]),
                          _c("div", { staticClass: "time-look" }, [
                            _c("div", [
                              _c("span", {
                                staticClass: "Time-down displayIB"
                              }),
                              _c("span", { staticClass: "text-down" }, [
                                _vm._v(" " + _vm._s(item.submissionTime) + " ")
                              ])
                            ]),
                            _c("div", [
                              _c("span", { staticClass: "see-down displayIB" }),
                              _c("span", { staticClass: "text-down" }, [
                                _vm._v(" " + _vm._s(item.viewingCount))
                              ])
                            ])
                          ])
                        ]
                      )
                    ]
                  )
                }),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.pageLength < _vm.count,
                        expression: "pageLength<count"
                      }
                    ],
                    staticClass: "marginAuto phone-more col33333 font22phone",
                    on: {
                      click: function($event) {
                        return _vm.getMore()
                      }
                    }
                  },
                  [_vm._v("\n          加载更多\n        ")]
                )
              ],
              2
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-205f531a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-205f531a","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/listPage/articlePage/articlePage.vue
// module id = 847
// module chunks = 3 4 5